// extracted by mini-css-extract-plugin
module.exports = {"richTextStyle":"_39oIkg-HsascgBy4BcC3Oh"};